export default {
  inventories: [],
  inventory: {}
};
